module.exports = __webpack_public_path__ + "img/money_1.d0fc4aae.svg";